const VALID_LENGTHS = [3, 6];
const MAX_LENGTH = 6;
const DEFAULT_COLOR = 'FFFFFF';
const HEX_REGEX = /^[0-9a-fA-F]+$/;

export function isAValidColor(value) {
  return HEX_REGEX.test(value);
}

export function isCompleteColor(value) {
  return isAValidColor(value) && VALID_LENGTHS.includes(value.length);
}

export function getCSSBackgroundColor(value, fallback = DEFAULT_COLOR) {
  const maxValue = value.slice(0, MAX_LENGTH);

  if (!isAValidColor(maxValue)) return `#${fallback}`;
  if (!VALID_LENGTHS.includes(value.length)) return `#${fallback}`;

  return `#${value}`;
}
